/* eslint-disable camelcase */
import React from 'react';
import LoadingSpinner from '../LoadingSpinner';
import { reviewsPerPageLimit } from '../../utils/constants';
import Pagination from '../Pagination';
import useReviews from './hooks/useReviews';
import Header from './elements/Header';
import FullReviewDialog from './elements/FullReviewDialog';

const Reviews = () => {
  const data = useReviews();

  const {
    waiting,
    reviews,
    currentPage,
    setCurrentPage,
    showFullReviewDialog,
    setShowFullReviewDialog,
    currentReview,
    expandReview,
  } = data;

  const getContents = () => {
    let outputArray;
    let numberOfPages = 0;

    if (reviews) {
      numberOfPages = Math.ceil(reviews.length / reviewsPerPageLimit);

      if (reviews.length > reviewsPerPageLimit) {
        let startIndex = reviewsPerPageLimit * currentPage;
        startIndex = startIndex === Infinity ? 0 : startIndex;
        const endIndex = (currentPage + 1) * reviewsPerPageLimit;

        outputArray = reviews.slice(startIndex, endIndex);
      } else {
        outputArray = reviews;
      }
    }

    return (
      <div>
        {reviews ? (
          <>
            <Header payload={data} />

            <div className="c-reviews-listing__body">
              {outputArray.map((review) => {
                const { id, title, shortened_review } = review;

                return (
                  <div
                    className="c-reviews-listing__body__item"
                    key={`review--${id}`}
                  >
                    <div className="c-reviews-listing__body__item__wrapper">
                      {title && (
                        <p className="c-reviews-listing__body__item__title o-text o-text--large o-text--heavy">
                          '{title}'
                        </p>
                      )}
                      <div
                        dangerouslySetInnerHTML={{ __html: shortened_review }}
                        className="c-reviews-listing__body__item__text o-text"
                      ></div>
                      <button
                        className="o-btn o-btn--more o-btn--purple"
                        onClick={() => expandReview(review)}
                      >
                        Expand
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>

            {numberOfPages > 1 && (
              <Pagination
                items={outputArray}
                numberOfPages={numberOfPages}
                setter={setCurrentPage}
                currentPage={currentPage}
              />
            )}
          </>
        ) : (
          <p>No reviews</p>
        )}
      </div>
    );
  };

  return (
    <div className="o-wrapper">
      <div className="c-reviews-listing">
        {waiting ? <LoadingSpinner /> : getContents()}
      </div>

      {showFullReviewDialog && (
        <FullReviewDialog
          setShow={setShowFullReviewDialog}
          title={currentReview.title}
          full_review={currentReview.full_review}
        />
      )}
    </div>
  );
};

export default Reviews;
